import * as React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import type { Socket } from 'socket.io-client';
import * as CONSTS from './constants';
import { SocketContext } from '@context/socket';
import { ReactComponent as LogoSecondaryIcon } from '@assets/svg/logo-secondary.svg';
import styles from './footer.module.scss';

const Footer = ({ fetched }: { fetched: boolean }): JSX.Element => {
    /* Hooks and State */

    const socket: Socket = React.useContext(SocketContext);

    const [isSocketConnected, setSocketConnected] = React.useState<
        boolean | null
    >(null);

    React.useEffect(() => {
        socket.on('connect', () => setSocketConnected(socket.connected));

        isSocketConnected === null && setSocketConnected(socket.connected);
    }, [socket]);

    /* Components */

    const InterestLinks: JSX.Element[] = CONSTS.LINKS.map((link: string) => (
        <Link to="" key={link} className={styles.navigation__link}>
            {link}
        </Link>
    ));

    const SocialMediaLinks: JSX.Element[] = CONSTS.SOCIAL_MEDIA.map(
        (media: React.ReactNode, idx: number) => (
            <a
                key={idx}
                className={styles['social-media__link']}
                href="#"
                rel="noopener noreferrer"
                target="_blank"
            >
                <figure>{media}</figure>
            </a>
        ),
    );

    /* ClassNames */

    const footerClasses: string = cn(styles.footer, {
        [styles.display]: fetched,
    });

    const socketStateClasses: string = cn(styles['socket-status__state'], {
        [styles.connected]: isSocketConnected !== null && isSocketConnected,
        [styles.disconnected]: isSocketConnected !== null && !isSocketConnected,
    });

    return (
        <footer className={footerClasses}>
            <section className={styles['duelana-data']}>
                <div className={styles.wrapper}>
                    <Link to="/" className={styles['duelana-data__info']}>
                        <figure>
                            <LogoSecondaryIcon />
                        </figure>
                        <p>Duelana Corp. Games ©{CONSTS.CURRENT_YEAR}</p>
                    </Link>
                    <nav className={styles.navigation}>{InterestLinks}</nav>
                </div>
            </section>
            <section className={styles['duelana-socket']}>
                <div className={styles.wrapper}>
                    <div className={styles['socket-status']}>
                        <p className={styles['socket-status__ping']}>Ping 48</p>
                        <span className={styles['socket-status__title']}>
                            Server Status
                        </span>
                        <p className={socketStateClasses}>
                            {isSocketConnected !== null
                                ? isSocketConnected
                                    ? 'Connected'
                                    : 'Disconnected'
                                : 'Loading'}
                        </p>
                    </div>

                    <nav className={styles['social-media']}>
                        {SocialMediaLinks}
                    </nav>
                </div>
            </section>
        </footer>
    );
};

export default Footer;
